export default __webpack_public_path__ + "static/media/green-small-tick.7af52615.svg";